import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Ui::Page>\n  Resource Type\n</Ui::Page>",{ moduleName: "garaje/pods/resources/resource-type/index/template.hbs" })